
<div class="item-qty">
    <div class="item-qty__header">
        <div class="item-qty__title">{{ isEditMode ? 'Edit Meal Request' : 'Add Meal Request' }}</div>
        <button type="button" class="item-qty__close" (click)="close()" aria-label="Close">×</button>
    </div>

    <div class="item-qty__body">
        <div class="field">
            <div class="field__label">Selected Kitchen</div>
            <input class="field__control" type="text" [value]="selectedKitchenName" readonly />
        </div>

        <div class="field">
            <div class="field__label">Select Meal Type</div>
            <div class="meal-types">
                <button
                    type="button"
                    class="meal-types__btn"
                    *ngFor="let s of scenarioTypes"
                    [class.meal-types__btn--active]="s.id === selectedScenarioId"
                    [disabled]="isScenarioDisabled(s)"
                    (click)="selectScenario(s.id)">
                    <mat-icon class="menu-tab__icon">{{ getScenarioIcon(s.scenarioName) }}</mat-icon>
                    {{ s.scenarioName }}
                </button>
            </div>
        </div>

        <div class="counts">
            <div class="counts__title">
                <span>Enter Counts</span>
                <span class="counts__student-total">
                   Scaits Student Count: {{ formatCount(apiStudentCount) }}
                </span>
            </div>

            <div class="counts__row">
                <div class="counts__label">Students</div>
                <input class="counts__input" type="text" inputmode="numeric" placeholder="0" maxlength="6"
                    [value]="studentCountDisplay"
                    (input)="onCountInput('studentCount', $event)"
                    (keydown)="onStudentCountKeydown($event)"
                    (blur)="onCountBlur('studentCount', $event)" />
            </div>
            <div class="counts__row">
                <div class="counts__label">Staff</div>
                <input class="counts__input" type="text" inputmode="numeric" placeholder="0" maxlength="6"
                    [value]="employeeCountDisplay"
                    (input)="onCountInput('employeeCount', $event)"
                    (blur)="onCountBlur('employeeCount', $event)" />
            </div>
            <div class="counts__row">
                <div class="counts__label">Sub-Staff</div>
                <input class="counts__input" type="text" inputmode="numeric" placeholder="0" maxlength="6"
                    [value]="subStaffCountDisplay"
                    (input)="onCountInput('subStaffCount', $event)"
                    (blur)="onCountBlur('subStaffCount', $event)" />
            </div>
            <div class="counts__row">
                <div class="counts__label">Others</div>
                <input class="counts__input" type="text" inputmode="numeric" placeholder="0" maxlength="6"
                    [value]="visitorsCountDisplay"
                    (input)="onCountInput('visitorsCount', $event)"
                    (blur)="onCountBlur('visitorsCount', $event)" />
            </div>

            <div class="counts__total">
                <div class="counts__label">Total Heads</div>
                <div class="counts__value">{{ formatCount(totalHeads) }}</div>
            </div>
        </div>

        <button type="button" class="submit-btn" (click)="submitRequest()">
            {{ isEditMode ? 'Update Request' : 'Submit Request' }}
        </button>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
